export const PrototypeTypes = {
  AcaciaI: "prototype.acaciaI",
  AcaciaIV: "prototype.acaciaIV",
  AcaciaXIX: "prototype.acaciaXIX",
};

export const FloorType = {
  LowFloor: "floor.lowFloor",
  TopFloor: "floor.topFloor",
  Terrace: "floor.terrace",
};

const prototypes = {
  [PrototypeTypes.AcaciaI]: {
    name: "prototype.acaciaI.name",
    terreno: "264",
    terrenoSqFt: "2,841",
    construccion: "281.74",
    construccionSqFt: "3,033",
    gallery: [
      "/assets/casas-velasur/Acacia I/img-acacia-i-casas-velasur.jpeg",
      "/assets/casas-velasur/Acacia I/img-recamara-acacia_1-velasur.jpg",
      "/assets/casas-velasur/Acacia I/img-acceso-acacia_1-velasur.jpg",
      "/assets/casas-velasur/Acacia I/img-bano-rec-acacia_1-velasur.jpg",
      "/assets/casas-velasur/Acacia I/img-comedor-acacia_-1.jpg",
      "/assets/casas-velasur/Acacia I/img-comedor-acacia_1-velasur.jpg",
      "/assets/casas-velasur/Acacia I/img-jardin-acacia_1-velasur.jpg",
    ],
    floor: {
      [FloorType.LowFloor]: {
        title: "floor.lowFloor",
        features: [
          { characteristics: "floor.features.kitchenEquipped", additional: "" },
          { characteristics: "floor.features.halfBath", additional: "" },
          { characteristics: "floor.features.serviceRoom", additional: "floor.features.withFullBath" },
          { characteristics: "floor.features.terraceGarden", additional: "" },
          { characteristics: "floor.features.parkingFor3Cars", additional: "" },
          { characteristics: "floor.features.grill", additional: "" },
          { characteristics: "floor.features.pool", additional: "floor.features.optionalExtraCost" },
          { characteristics: "floor.features.pergola", additional: "floor.features.optionalExtraCost" },
        ],
        floorImage: "/assets/casas-velasur/Acacia I/img-acacia-i-baja-casas-velasur.jpg",
      },
      [FloorType.TopFloor]: {
        title: "floor.topFloor",
        features: [
          { characteristics: "floor.features.threeBedrooms", additional: "" },
          { characteristics: "floor.features.threeBathrooms", additional: "floor.features.includesDressingRoomBalcony" },
        ],
        floorImage: "/assets/casas-velasur/Acacia I/img-acacia-i-alta-casas-velasur.jpg",
      },
    },
  },
  [PrototypeTypes.AcaciaIV]: {
    name: "prototype.acaciaIV.name",
    terreno: "264",
    terrenoSqFt: "2,841",
    construccion: "237.82",
    construccionSqFt: "2,559",
    gallery: [
      "/assets/casas-velasur/Acacia iv/img-acacia-iv-casas-velasur.jpeg",
      "/assets/casas-velasur/Acacia iv/img-jardin_b-acacia_iv-velasur.jpg",
      "/assets/casas-velasur/Acacia iv/img-recamara-acacia_iv-velasur.jpg",
      "/assets/casas-velasur/Acacia iv/img-sala_tv-acacia_iv-velasur.jpg",
      "/assets/casas-velasur/Acacia iv/img-sala-acacia_iv-velasur.jpg",
      "/assets/casas-velasur/Acacia iv/img-comedor-acacia_iv-velasur.jpg",
      "/assets/casas-velasur/Acacia iv/img-bano-acacia_iv-velasur.jpg",
      "/assets/casas-velasur/Acacia iv/img-jardin_-acacia_iv-velasur.jpg",
    ],
    floor: {
      [FloorType.LowFloor]: {
        title: "floor.lowFloor",
        surface: "107.63",
        features: [
          { characteristics: "floor.features.kitchenEquipped", additional: "" },
          { characteristics: "floor.features.fullBathroom", additional: "" },
          { characteristics: "floor.features.serviceRoom", additional: "floor.features.withFullBath" },
          { characteristics: "floor.features.terraceGarden", additional: "" },
          { characteristics: "floor.features.parkingFor3Cars", additional: "" },
          { characteristics: "floor.features.tvRoom", additional: "" },
          { characteristics: "floor.features.pool", additional: "floor.features.optionalExtraCost" },
          { characteristics: "floor.features.pergola", additional: "floor.features.optionalExtraCost" },
        ],
        floorImage: "/assets/casas-velasur/Acacia iv/img-acacia-iv-alta-casas-velasur.jpg",
      },
      [FloorType.TopFloor]: {
        title: "floor.topFloor",
        surface: "117.61",
        features: [
          { characteristics: "floor.features.threeBedrooms", additional: "" },
          { characteristics: "floor.features.threeBathrooms", additional: "floor.features.includesSharedBalcony" },
        ],
        floorImage: "/assets/casas-velasur/Acacia iv/img-acacia-iv-baja-casas-velasur.jpg",
      },
    },
  },
  [PrototypeTypes.AcaciaXIX]: {
    name: "prototype.acaciaXIX.name",
    terreno: "264",
    terrenoSqFt: "2,841",
    construccion: "263.89",
    construccionSqFt: "2,841", // Ajusta valor real si tienes dato correcto
    gallery: [
      "/assets/casas-velasur/acacia xix/img-acacia-xix-casas-velasur.jpeg",
      "/assets/casas-velasur/acacia xix/img-sala-acacia_xix-velasur.jpg",
      "/assets/casas-velasur/acacia xix/img-recamara-acacia_xix-velasur.jpg",
      "/assets/casas-velasur/acacia xix/img-recamara_pal-acacia_xix-velasur.jpg",
      "/assets/casas-velasur/acacia xix/img-pasillo_patio-acacia_xix-velasur.jpg",
      "/assets/casas-velasur/acacia xix/img-jardin-acacia_xix-velasur.jpg",
      "/assets/casas-velasur/acacia xix/img-cocina-acacia_xix-velasur.jpg",
      "/assets/casas-velasur/acacia xix/img-bar-acacia_xix-velasur.jpg",
    ],
    floor: {
      [FloorType.LowFloor]: {
        title: "floor.lowFloor",
        surface: "128.65",
        features: [
          { characteristics: "floor.features.kitchenEquipped", additional: "" },
          { characteristics: "floor.features.bar", additional: "" },
          { characteristics: "floor.features.halfBath", additional: "" },
          { characteristics: "floor.features.laundryRoom", additional: "" },
          { characteristics: "floor.features.terraceGarden", additional: "" },
          { characteristics: "floor.features.parkingFor3Cars", additional: "" },
          { characteristics: "floor.features.pool", additional: "floor.features.optionalExtraCost" },
          { characteristics: "floor.features.pergola", additional: "floor.features.optionalExtraCost" },
        ],
        floorImage: "/assets/casas-velasur/acacia xix/img-acacia-xix-alta-casas-velasur.jpg",
      },
      [FloorType.TopFloor]: {
        title: "floor.topFloor",
        surface: "124.39",
        features: [
          { characteristics: "floor.features.threeBedrooms", additional: "" },
          { characteristics: "floor.features.threeBathrooms", additional: "floor.features.includesDressingRoomBalcony" },
        ],
        floorImage: "/assets/casas-velasur/acacia xix/img-acacia-xix-baja-casas-velasur.jpg",
      },
    },
  },
};

export const getPrototype = (prototypeType) => prototypes[prototypeType] ?? {};
